export class TaskDefaultValue {
  constructor(date) {
    this.date = date;
    this.eventsCount = 0;
    this.value = null;
    this.list = [];
  }
}
